import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { AcelenData } from '../interfaces/public-query.interface';
import { Expedition } from '../interfaces/expedition.interface';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class PublicQueryService {

  constructor(private http: HttpClient) { }

  public findAllByIdentificador(
    payload: {
      identifier?: string,
      trackingCode?: string,
      productHash?: string,
      customerDocument?: string,
      providerDocument?: string,
      productionDate?: string
    }): Observable<Expedition[]> {

    let params = new HttpParams();

    if (payload.identifier) {
      params = params.set('identifier', payload.identifier)
    }
    if (payload.trackingCode) {
      params = params.set('trackingCode', payload.trackingCode)
    }
    if (payload.customerDocument) {
      params = params.set('customerDocument', payload.customerDocument)
    }
    if (payload.providerDocument) {
      params = params.set('providerDocument', payload.providerDocument);
    }
    if (payload.productHash) {
      params = params.set('productHash', payload.productHash);
    }
    if (payload.productionDate) {
      params = params.set('productionDate', payload.productionDate);
    }

    return this.http.get<Expedition[]>(`${environment.api}/movement-service/find-by-identifier`, { params }).pipe(
      (res) => res,
      (error) => error,
    );
  }

  public findAcelenProduct(id: string): Observable<AcelenData> {

    return this.http.get<AcelenData>(`${environment.api}/cache-traceability/${id}`).pipe(
      (res) => res,
      (error) => error,
    );
  }

  public findProductByEanAndProviderDoc(ean: string, providerDocument: string): Observable<any> {
    let params = new HttpParams().set('ean', ean).set('providerDocument', providerDocument);

    return this.http.get<any>(`${environment.api}/enterprise-product-service/find-by-ean-and-provider-document`, { params })
  }
}
